import {
  IconDeviceFloppy,
  IconPhoto,
  IconUpload,
  IconX,
} from "@tabler/icons-react";
import { memo } from "react";
import { Alert, Badge, Button, Card, Col, Row, Spinner } from "react-bootstrap";

const ImageLibraryTab = memo(
  ({
    imageLibrary,
    apiImageLibrary,
    uploadedImages,
    imageLoading,
    handleImageUpload,
    removeImage,
  }) => {
    const allImages = [...imageLibrary, ...apiImageLibrary, ...uploadedImages];

    return (
      <div>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="mb-0">
            <IconPhoto className="me-2" />
            Biblioteca de Imagens
          </h3>
          {imageLoading && (
            <div className="d-flex align-items-center">
              <Spinner size="sm" className="me-2" />
              <small className="text-muted">Carregando...</small>
            </div>
          )}
        </div>

        <Alert variant="info" className="mb-4">
          Faça upload das imagens que o agente poderá usar durante as conversas.
          <strong> Limite máximo: 1MB por imagem.</strong>
        </Alert>

        <Card className="mb-4">
          <Card.Body>
            <div className="text-center py-4">
              <IconUpload size={48} className="text-muted mb-3" />
              <h6>Adicionar Imagens</h6>
              <p className="text-muted mb-3">
                Arraste arquivos aqui ou clique para selecionar (máximo 1MB
                cada)
              </p>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageUpload}
                style={{ display: "none" }}
                id="imageUpload"
                disabled={imageLoading}
              />
              <Button
                variant="outline-primary"
                onClick={() => document.getElementById("imageUpload").click()}
                disabled={imageLoading}
              >
                {imageLoading ? (
                  <Spinner size="sm" className="me-1" />
                ) : (
                  <IconPhoto className="me-1" size={16} />
                )}
                Selecionar Imagens
              </Button>
            </div>
          </Card.Body>
        </Card>

        {/* Combined Image Library */}
        {allImages.length > 0 && (
          <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Imagens Disponíveis ({allImages.length})</h6>
              <div className="d-flex gap-2">
                <Badge bg="primary" className="d-flex align-items-center">
                  <IconPhoto size={14} className="me-1" />
                  Biblioteca: {imageLibrary.length}
                </Badge>
                <Badge bg="info" className="d-flex align-items-center">
                  <IconUpload size={14} className="me-1" />
                  API: {apiImageLibrary.length}
                </Badge>
                <Badge bg="success" className="d-flex align-items-center">
                  <IconDeviceFloppy size={14} className="me-1" />
                  Upload: {uploadedImages.length}
                </Badge>
              </div>
            </div>

            <Row>
              {allImages.map((image, index) => {
                const isFromUpload = uploadedImages.some(
                  (img) => img.id === image.id
                );
                const isFromAPI = apiImageLibrary.some(
                  (img) => img.id === image.id
                );
                const isFromProp = imageLibrary.some(
                  (img) => img.id === image.id
                );

                return (
                  <Col md={3} key={`${image.id}-${index}`} className="mb-3">
                    <Card>
                      <div
                        style={{
                          height: "200px",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <Card.Img
                          variant="top"
                          src={image.url}
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                        {/* Badge para identificar origem */}
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            left: "5px",
                          }}
                        >
                          {isFromUpload && (
                            <Badge bg="success" size="sm">
                              Upload
                            </Badge>
                          )}
                          {isFromAPI && (
                            <Badge bg="info" size="sm">
                              API
                            </Badge>
                          )}
                          {isFromProp && (
                            <Badge bg="primary" size="sm">
                              Biblioteca
                            </Badge>
                          )}
                        </div>
                      </div>
                      <Card.Body className="p-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <small className="text-muted d-block">
                              {image.name}
                            </small>
                            <small className="text-muted">
                              {image.size
                                ? (image.size / 1024 / 1024).toFixed(2) + " MB"
                                : "N/A"}
                            </small>
                          </div>
                          {(isFromUpload || isFromAPI) && (
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => removeImage(image.id)}
                              disabled={imageLoading}
                            >
                              {imageLoading ? (
                                <Spinner size="sm" />
                              ) : (
                                <IconX size={14} />
                              )}
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}

        {allImages.length === 0 && !imageLoading && (
          <div className="text-center py-5 text-muted">
            <IconPhoto size={48} className="mb-3" />
            <p>Nenhuma imagem na biblioteca.</p>
            <p>
              As imagens facilitam a comunicação e deixam o atendimento mais
              visual.
            </p>
          </div>
        )}

        {imageLoading && allImages.length === 0 && (
          <div className="text-center py-5">
            <Spinner className="mb-3" />
            <p className="text-muted">Carregando biblioteca de imagens...</p>
          </div>
        )}
      </div>
    );
  }
);

ImageLibraryTab.displayName = "ImageLibraryTab";
export default ImageLibraryTab;
